import React from "react";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import "../styles/auth.css";

const UserAgreement = () => {
  return (
    <div className="legal-container">
      <Navbar />

      <div className="legal-content">
        <h1>User Agreement</h1>

        <p>Last Updated: March 2026</p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By creating an account or using Mark & Luth, you agree to comply with
          these terms and conditions.
        </p>

        <h2>2. User Responsibilities</h2>
        <p>
          Users must provide accurate information when creating an account and
          must not misuse the platform.
        </p>

        <h2>3. Orders and Payments</h2>
        <p>
          All purchases made through the website are subject to product
          availability and payment verification.
        </p>

        <h2>4. Intellectual Property</h2>
        <p>
          All content on this website including logos, images, and text are the
          property of Mark & Luth and cannot be copied or reused without
          permission.
        </p>

        <h2>5. Account Suspension</h2>
        <p>
          We reserve the right to suspend or terminate accounts that violate
          our policies or engage in fraudulent activities.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          Mark & Luth is not responsible for any indirect damages resulting
          from the use of our website.
        </p>

        <h2>7. Changes to Terms</h2>
        <p>
          These terms may be updated at any time. Continued use of the website
          indicates acceptance of the updated terms.
        </p>
      </div>

      <BottomNav />
    </div>
  );
};

export default UserAgreement;